<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle"><a id="ch00_fm01_htitle"></a><a id="page_1"></a><strong>Tell Me What to Eat If I Have Acid Reflux</strong><a id="page_2"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm01_htitle.vue?6f56e798